/**
 * MODULE: _shared/frontend-shell/src/pages/MessagingShellSkeleton.tsx
 * PURPOSE: Route-level loading chrome for lazy /messaging — prevents prior route content flash (#109)
 * DEPENDENCIES: none
 * PUBLIC_API: MessagingShellSkeleton
 * SIDE_EFFECTS: none
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: 38 / 150 lines
 * RECENT: 2026-05-22 [2.2.1132] — **`data-testid="messaging-shell-skeleton"`**; Playwright **`11-app-shell-navigation`**. [2.2.1132]
 */

export function MessagingShellSkeleton() {
  return (
    <div
      className="flex h-full min-h-[60vh] flex-col bg-gray-50 dark:bg-gray-900"
      role="status"
      aria-live="polite"
      aria-busy="true"
      data-testid="messaging-shell-skeleton"
    >
      <span className="sr-only">Loading messaging</span>
      <div className="border-b border-gray-200 bg-white px-4 py-3 dark:border-gray-700 dark:bg-gray-800">
        <div className="mx-auto flex max-w-6xl gap-2">
          {['Inbox', 'Sequences', 'Templates'].map((label) => (
            <div
              key={label}
              className="h-9 w-24 animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700"
              aria-hidden
            />
          ))}
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-4 p-6">
        <div className="h-8 w-48 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
        <div className="h-32 animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700" />
        <div className="h-64 animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700" />
      </div>
    </div>
  );
}
